import type { SaleChange } from '../types/saleChange';
import { resolveSaleChangeAmounts } from './resolveSaleChangeAmounts';

export const getSaleChangeTotalAmountCents = (saleChange: SaleChange | null | undefined): number =>
  saleChange?.finalAmount.amountCents ?? 0;

export const getSaleChangeComparisonAmounts = (saleChange: SaleChange | null | undefined) =>
  resolveSaleChangeAmounts(saleChange);

export const saleChangeSummaryHasComparison = (saleChange: SaleChange | null | undefined): boolean => {
  const { downAmount, upAmount } = resolveSaleChangeAmounts(saleChange);

  return downAmount !== undefined && upAmount !== undefined;
};
